import axiosLocal from '@/services/rest/index';

export const SimulateTransactionServices = {
    async postTransactionAuthorisation(transaction: any): Promise<any[]> {
        return axiosLocal.post(`/rtf/webhook/authorisation`, transaction).then((response: any) => {
            return response.data;
        });
    },

    async postTransactionPurchase(transaction: any): Promise<any[]> {
        return axiosLocal.post(`/rtf/webhook/transaction`, transaction).then((response: any) => {
            return response.data;
        });
    },
};
